module.exports = __webpack_public_path__ + "static/img/icon-safe2.867f2aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-safe2.png
// module id = mM4L
// module chunks = 21